import { Capacitor } from '@capacitor/core'

export type AppShell = 'ios' | 'android' | 'pwa' | 'browser'

export function appShell(): AppShell {
  const platform = Capacitor.getPlatform()
  if (platform === 'ios' || platform === 'android') return platform
  const standalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  return standalone ? 'pwa' : 'browser'
}
